import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../Airoom.css';
import TextField from "../../core/common/textFields/TextField";
import { useGetOrganizationDataQuery, useUpdateOrganizationMutation } from "../../services/EndPointsApis";
import "../../style/css/index.css";
import { all_routes } from "../router/all_routes";
import "./Organization.css";
import Select, { StylesConfig } from "react-select";
import { InputMask } from "@react-input/mask";


const route = all_routes;

const Organization = () => {

  const customStyles: StylesConfig = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "rgba(177, 31, 40, 1)" : "#fff",
      color: state.isFocused ? "#fff" : "#000",
      "&:hover": {
        backgroundColor: "rgba(177, 31, 40, 1)",
      },
    }),
  };
  const [isEditing, setisEditing] = useState(false)
  const [updateId, setUpdateId] = useState(0);

  const handleSaveOrganization = () => {
    setisEditing(false);
    formik.handleSubmit();
  }

  const handleEditOrganization = (e: any) => {
    e.preventDefault()
    setisEditing(true);
  }

  const optionsCountry = [
    { id: 'Choose', label: 'Choose' },
    { id: '1', label: 'US' },
  ];
  const { data: organizationData, refetch } = useGetOrganizationDataQuery('');
  const [updateOrganization, { data, isError, error, isSuccess, isLoading }] = useUpdateOrganizationMutation();


  const initialValues = {
    emailAddress: '',
    legalAddrLine1: '',
    webURL: '',
    legalName: '',
    country: {
      id: 0,
      title: ''
    },
    legalState: '',
    legalCity: '',
    legalZip: '',
    orgDescription: '',
    contactPersonName: '',
    contactPersonEmail: '',
    contactPersonMobile: '',
    businessContact: '',
    tenantId: '',
    domainName: '',
    internalNotes: '',
  }

  const formik = useFormik({
    initialValues,
    // validationSchema: loginSchema,
    onSubmit: (values) => {
      updateOrganization({ ...values });
    },
  });
  useEffect(() => {

    // Update form values based on data received
    if (organizationData) {
      setUpdateId(organizationData?.result?.organizationID);
      formik.setValues({ ...organizationData?.result });
      
    }
  }, [organizationData]);
  useEffect(() => {
    if (isSuccess) {
      toast.success(data?.message);
      refetch();
    }
  }, [isSuccess]);

  useEffect(() => {
    if (isError && error) {
      let errorMessage: string = 'Something went wrong';

      if ('data' in error && error.data && typeof error.data === 'object' && 'message' in error.data) {
        errorMessage = (error.data as { message: string }).message;
      }
      toast.error(errorMessage);
    }
  }, [isError, error]);

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <form onSubmit={formik.handleSubmit}>
            <div className="row">
              <div className="col-md-12">
                {/* /Page Header */}
                <div className="card card-css">
                  <div className="card-body card-padding">
                    <div className="d-flex align-items-center justify-content-between">
                      <div>
                        <h3 className="page-title color-red mb-2">My Organization</h3>
                      </div>
                      <div className="d-flex gap-3 align-items-center">
                        {
                          !isEditing ? (
                            <button className="mb-0 btn btn-primary" type="button" onClick={handleEditOrganization}><span className="me-1"><i className="fa fa-edit"></i></span> Edit </button>

                          ) : (
                            <button className="btn btn-primary" type="submit" onClick={handleSaveOrganization}>Save </button>
                          )
                        }
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="card h-100">
                  <div className="card-body">
                    <div>
                      <h5>Organization Details</h5>
                    </div>
                    <div className="col-md-12 mt-3">
                      <TextField
                        label=" Organization Name"
                        required
                        type="text"
                        {...formik.getFieldProps("legalName")}
                        disabled={!isEditing}
                      />
                    </div>
                    <div className="col-md-12 mt-3">
                      <TextField
                        label="  Website URL"
                        required
                        type="text"
                        {...formik.getFieldProps("webURL")}
                        disabled
                      />
                    </div>
                    <div className="col-md-12 mt-3">
                      <TextField
                        label=" Address"
                        required
                        type="text"
                        {...formik.getFieldProps("legalAddrLine1")}
                        disabled={!isEditing}
                      />
                    </div>
                    <div className="col-md-12 mt-3">
                      <label className="input-label">
                        Country
                      </label>
                      <Select
                        styles={customStyles}
                        className="select"
                        options={optionsCountry?.map((option: any) => ({
                          label: option?.label,
                          value: option?.id
                        }))}
                        // options={optionsCountry}
                        value={
                          formik.values?.country?.id
                            ? {
                              value: formik.values?.country?.id,
                              label: formik.values?.country?.title || '',
                            }
                            : null
                        }
                        isDisabled={!isEditing}
                        onChange={(selectedOption: any) => {
                          formik.setFieldValue('country.id', selectedOption.value);
                          formik.setFieldValue('country.title', selectedOption.label);
                        }} />
                    </div>
                    <div className="col-md-12 mt-3">
                      <TextField
                        label="State/Region"
                        required
                        type="text"
                        {...formik.getFieldProps("legalState")}
                        disabled={!isEditing}
                      />
                    </div>
                    <div className="col-md-12 mt-3">
                      <TextField
                        label="City"
                        required
                        type="text"
                        {...formik.getFieldProps("legalCity")}
                        disabled={!isEditing}
                      />
                    </div>
                    <div className="col-md-12 mt-3">
                      <TextField
                        label="Zipcode"
                        required
                        type="text"
                        {...formik.getFieldProps("legalZip")}
                        disabled={!isEditing}
                      />
                    </div>
                    <div className="col-md-12 mt-3">
                      <label className="input-label ">
                        Organization Description
                      </label>
                      <textarea className="form-control height-150" {...formik.getFieldProps("orgDescription")} disabled
                      />
                    </div>
                  </div>

                </div>
              </div>
              <div className="col-md-6">
                <div className="card h-100">
                  <div className="card-body">
                    <div>
                      <h5>Contact Details</h5>
                    </div>
                    <div className="col-md-12 mt-3">
                      <TextField
                        label=" Contact Name"
                        required
                        type="text"
                        {...formik.getFieldProps("contactPersonName")}
                        disabled={!isEditing}
                      />
                    </div>
                    <div className="col-md-12 mt-3">
                      <TextField
                        label="Email Address"
                        required
                        type="text"
                        {...formik.getFieldProps("contactPersonEmail")}
                        disabled={!isEditing}
                      />
                    </div>
                    <div className="col-md-12 mt-3">
                      <label className="input-label">Contact</label>
                      <InputMask mask=" +1-___-___-____"
                        replacement={{ _: /\d/ }}
                        placeholder="+1(847)763-1100"
                        className="form-control"
                        {...formik.getFieldProps("contactPersonMobile")}
                        disabled={!isEditing}
                      />
                    </div>
                    <div className="col-md-12 mt-3">
                      <label className="input-label">Business Contact</label>
                      <InputMask mask=" +1-___-___-____"
                        replacement={{ _: /\d/ }}
                        placeholder="+1(847)763-1100"
                        className="form-control"
                        {...formik.getFieldProps("businessContact")}
                        disabled={!isEditing}
                      />
                    </div>
                    <div className="col-md-12 mt-3">
                      <TextField
                        label="Tenant ID"
                        required
                        type="text"
                        {...formik.getFieldProps("tenantId")}
                        disabled={!isEditing}
                      />
                    </div>
                    <div className="col-md-12 mt-3">
                      <TextField
                        label=" Primary Domain"
                        required
                        type="text"
                        {...formik.getFieldProps("domainName")}
                        disabled={!isEditing}
                      />
                    </div>
                    <div className="col-md-12 mt-3">
                      <label className="input-label">
                        Internal Notes
                      </label>
                      <textarea className="form-control height-150" value={organizationData?.result?.internalNotes} disabled />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Organization;
